import firebase from 'firebase';

export default {
  collection() {
    return firebase.firestore().collection('settings');
  },

  async getPublicSettings() {
    try {
      const snapshot = await this.collection()
        .doc('public')
        .get();

      return snapshot.data() || {};
    } catch (e) {
      console.error('get settings error', e);
      return {};
    }
  }
};
